
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface StrategySortingProps {
  sortBy: string;
  onSortChange: (value: string) => void;
}

const StrategySorting = ({ sortBy, onSortChange }: StrategySortingProps) => {
  return (
    <div className="w-full sm:w-48">
      <Select value={sortBy} onValueChange={onSortChange}>
        <SelectTrigger className="w-full bg-white border-[#D3DCE4]">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="performance">PNL Ratio (High to Low)</SelectItem>
          <SelectItem value="amount-high">Amount (High to Low)</SelectItem>
          <SelectItem value="amount-low">Amount (Low to High)</SelectItem>
          <SelectItem value="risk">Risk Level (Low to High)</SelectItem>
          <SelectItem value="followers">Most Popular</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default StrategySorting;
